// extracted by mini-css-extract-plugin
module.exports = {"td--body":"td--body__1KDZl"};